import {  Component, OnInit } from '@angular/core'
import {
  DataPageOfReportCategory,
  DataPageOfReportCategoryDto,
  ManageRoles,
  ReportCategory,
  ReportCategoryDto,
} from '../../../../api/models'
import { ReportCategoryService, RolesService } from '../../../../api/services'
import { MessageService, ConfirmationService } from 'primeng/api'

@Component({
  selector: 'app-reports-category',
  templateUrl: './reports-category.component.html',
  styleUrls: ['./reports-category.component.css'],
})
export class ReportsCategoryComponent implements OnInit {
  cols: { field: string; header: string }[]
    reportCategories: DataPageOfReportCategory
    reportCategories_new: DataPageOfReportCategoryDto
  selectedCategories: ReportCategory
  showRecords: boolean = false
  update: boolean
  addEditReportCategory: ReportCategory = {}
  reportCategoryOperation: string
  rows: number
 
    selectedRole?: ManageRoles

    rolesList: Array<ManageRoles>
    selectedRoles?: Number[] = []; 


    selectedReportCategoryDto: ReportCategoryDto;
    addEditReportCategoryDto: ReportCategoryDto = {}
  constructor(
    private reportcategoryservice: ReportCategoryService,
    private _roleService: RolesService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
     
  ) {}

  ngOnInit() {
    this.cols = [
        { field: 'reportCategoryName', header: 'Category Name' },
      /*, { field: 'roleName', header: 'Role' }*/
    ]
    this.loadRoleList()
      // this.LoadReportCategoryList()
      this.LoadReportCategoryList_New()
  }
  LoadReportCategoryList(): void {
    debugger
    this.reportcategoryservice
      .reportCategoryGet({
        pageNumber: 1,
        pageSize: 10,
      })
      .subscribe((result) => {
        debugger
        this.reportCategories = result

        this.rows = this.reportCategories.pageSize
        if (result.totalRecords > 0) {
          this.showRecords = true
        } else {
          this.showRecords = false
        }

        console.log(result)
      })
  }




    LoadReportCategoryList_New(): void {
     //   debugger

      
        this.reportcategoryservice
            .reportCategoryGetAll({
                pageNumber: 1,
                pageSize: 10,
            })
            .subscribe((result) => {
                debugger
                this.reportCategories_new = result

                console.log("this.reportCategories_new");
                console.log(this.reportCategories_new);

                this.rows = this.reportCategories_new.pageSize
                if (result.totalRecords > 0) {
                    this.showRecords = true
                } else {
                    this.showRecords = false
                }

                console.log(result)
            })
    }





  loadRoleList(): void {
      this._roleService.rolesList({ pageNumber:-999}).subscribe((data) => {
      debugger
      this.rolesList = data.data
    })
  }

    onAddReportCategory(): void {
        this.update = true
        this.reportCategoryOperation = 'Create';
        this.addEditReportCategoryDto = {};
        this.selectedRoles = null;
      this.addEditReportCategory = {}
      this.selectedRole = undefined;
  }
  onEdit(rCategory: ReportCategory): void {
    debugger
    //this.selectedRole = this.rolesList.find(
    //  (role) => role.roleId === rCategory.roleId,
    //)
    // Clone the category object to avoid modifying the original
    this.addEditReportCategory = { ...rCategory }

    this.update = true
    this.reportCategoryOperation = 'Update'
  }

  dropcategory(event: Event, reportcategoryId: number) {
    debugger
    if (event.defaultPrevented) return
    event.preventDefault()

    this.confirmation.confirm({
      key: 'delete_confirmation',
      message: 'Are you sure you want to delete this category?',
      accept: () => {
        this.onDeleteReportCategory(reportcategoryId)
      },
    })
  }

  onDeleteReportCategory(id: number): void {
    this.reportcategoryservice
      .reportCategoryDelete({ id: id })
      .subscribe((result) => {
        if (result.status.toLowerCase().indexOf('error') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: result.message,
            summary: 'ERROR',
            life: 7000,
          })
        } else if (result.status.toLowerCase().indexOf('ok') > -1) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            detail: result.message,
            summary: 'Confirmation',
            life: 7000,
          })
            this.LoadReportCategoryList_New();
        }
      })
  }

  saveReportCategory(): void {
    debugger
    if (
      !this.addEditReportCategory.reportcategoryname ||
      (this.addEditReportCategory.reportcategoryname &&
        this.addEditReportCategory.reportcategoryname.length === 0)
    ) {
      this.messageService.add({
        key: 'alertToast',
        severity: 'error',
        summary: 'ERROR',
        detail:
          'Cannot save Category without Category Name, please enter Category Name.',
      })
      return
    }

    if (
      !this.selectedRole ||
      (this.selectedRole.roleId && this.selectedRole.roleId === 0)
    ) {
      this.messageService.add({
        key: 'alertToast',
        severity: 'error',
        summary: 'ERROR',
        detail: 'Cannot save Category without Role, Please selected the Role.',
      })
      return
    }

    if (!this.addEditReportCategory.reportcategoryid) {
     // this.addEditReportCategory.roleId = this.selectedRole.roleId
      this.reportcategoryservice
        .reportCategoryPost({
          body: this.addEditReportCategory,
        })
        .subscribe(
          (val) => {
            debugger

            if (val) {
              this.messageService.add({
                key: 'alertToast',
                severity: 'success',
                summary: 'Confirmation',
                detail: `Report Category was saved successfully `,
                life: 5000,
              })
              this.update = false
              this.LoadReportCategoryList()
              this.resetVariables()
            }
          },
          (err) => {
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              summary: 'ERROR',
              detail: `Error while saving Report Category`,
              life: 5000,
            })
            console.error(err)
            this.update = false
          },
        )
    } else {
      //this.addEditReportCategory.roleId = this.selectedRole.roleId
      this.reportcategoryservice
        .reportCategoryPut$Response({
          id: 1,
          body: this.addEditReportCategory,
        }).subscribe(
          (val) => {
            if (val) {
              this.messageService.add({
                key: 'alertToast',
                severity: 'success',
                summary: 'Confirmation',
                detail: `Category was updated successfully `,
                life: 5000,
              })
              this.update = false
              this.LoadReportCategoryList()
              this.resetVariables()
            }
          },
          (err) => {
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              summary: 'ERROR',
              detail: `Error while saving Category`,
              life: 5000,
            })
            console.error(err)
            this.update = false
          },
        )
    }
  }

     saveReportCategoryNewDTO(): void {
       //debugger;

        // Validate Report Category Name
        if (!this.addEditReportCategoryDto.reportCategoryName?.trim()) {
            // this.showErrorToast('Cannot save Category without Category Name, please enter Category Name.');

            this.messageService.add({ key: 'alertToast', severity: 'error',   summary: 'ERROR', detail:'Cannot save Category without Category Name, please enter Category Name.' })
            return;
            
        }

        // Validate Selected Roles
        if (!this.selectedRoles?.length) {
            this.messageService.add({ key: 'alertToast', severity: 'error', summary: 'ERROR',detail: 'Cannot save Category without Role, Please selected the Role.'})
            return;
        }
        const roleIds = this.selectedRoles.filter((roleId) => typeof roleId === 'number');         

        // Prepare DTO
        const reportCategoryDto: ReportCategoryDto = {
            reportCategoryId: this.addEditReportCategoryDto.reportCategoryId || 0,
            reportCategoryName: this.addEditReportCategoryDto.reportCategoryName,
            roleIds: roleIds as Array<number> 
        };

        // Save or Update Report Category
        if (!this.addEditReportCategoryDto.reportCategoryId) {
            this.reportcategoryservice.reportCategoryAddReportCategoryWithRoles({ body: reportCategoryDto })
                .subscribe({
                    next: (val) => {
                        if (val) {
                            this.messageService.add({
                                key: 'alertToast',
                                severity: 'success',
                                summary: 'Confirmation',
                                detail: `Report Category was saved successfully `,
                                life: 5000,
                            })
                            this.update = false;
                            this.LoadReportCategoryList_New();
                            this.resetVariables();
                        }
                    },
                    error: (err) => {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'error',
                            summary: 'ERROR',
                            detail: `This reportcategory name is already taken.Please choose another reportcategory name.!`,
                            life: 5000,
                        })
                        console.error(err);
                        this.update = false;
                    }
                });
        }
        else
        {
            this.reportcategoryservice.reportCategoryUpdate({ id: reportCategoryDto.reportCategoryId, body: reportCategoryDto })
                .subscribe({
                    next: (val) => {
                        if (true)
                        {
                            this.messageService.add({
                                key: 'alertToast',
                                severity: 'success',
                                summary: 'Confirmation',
                                detail: `Report Category was updated successfully `,
                                life: 5000,
                            })
                            this.update = false;
                            this.LoadReportCategoryList_New();
                            this.resetVariables();
                           
                        }
                    },
                    error: (err) => {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'error',
                            summary: 'ERROR',
                            detail: `This reportcategory name is already taken.Please choose another reportcategory name.!`,
                            life: 5000,
                        })

                        console.log(err);

                        this.update = false;
                    }
                });

            
            

        }
    }



    onEditDTO(rCategory: ReportCategoryDto): void {
        // Copies the data of rCategory into addEditReportCategoryDto
        this.addEditReportCategoryDto = { ...rCategory };      

        // Check if there are any roles selected for the category
        if (rCategory.roleIds && rCategory.roleIds.length > 0) {
            // If there are roles selected, copy them into the selectedRoles array
            this.selectedRoles = rCategory.roleIds;
            // Logging the selected roles and available roles to help with debugging
            console.log('Selected Roles:', this.selectedRoles);
            console.log('Roles List:', this.rolesList);

            // Filter out invalid values from selectedRoles, like the role which does not exists.
            this.selectedRoles = this.selectedRoles.filter(role =>
                this.rolesList.some(item => item.roleId === role)
            );

            // Set the UI to editing mode (you might be showing a form with this data)
            this.update = true;
            this.reportCategoryOperation = 'Update';
        }
    }


  private resetVariables(): void {
      this.addEditReportCategoryDto = {};
      this.selectedRoles = null;
  }
}
